import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import s from './Sidebar.scss';
import Filters from '../Filters';

const sidebarRef = React.createRef();

const Sidebar = ({
  isSticky,
  filterProps: { filters, onFilterChange },
  component: Component,
  mode,
  showServiceMessage,
}) => {
  const filterElements = filters.map((filter, i) => {
    if (filter.type === 'filter') {
      return (
        <Filters
          key={filter.key}
          title={filter.key}
          group={filter.key}
          items={filter.items}
          order={i}
          ref={sidebarRef.current}
          onChange={onFilterChange}
          mode={mode}
        />
      );
    }
    if (filter.type === 'priceInterval') {
      return <></>;
    }
    throw new Error(`Invalid filter ${filter.toString()}`);
  });

  return (
    <Component
      className={cx(
        s.root,
        isSticky && s.isSticky,
        showServiceMessage && s.showServiceMessage,
      )}
      ref={sidebarRef}
    >
      <div className={s.content}>{filterElements}</div>
    </Component>
  );
};

Sidebar.propTypes = {
  filterProps: PropTypes.shape({
    onFilterChange: PropTypes.func.isRequired,
    filters: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string.isRequired,
        type: PropTypes.oneOf(['filter', 'priceInterval']),
        items: PropTypes.shape(), // Not required for type priceInterval
      }).isRequired,
    ).isRequired,
  }).isRequired,
  component: PropTypes.node,
  isSticky: PropTypes.bool.isRequired,
  mode: PropTypes.string.isRequired,
  showServiceMessage: PropTypes.bool.isRequired,
};

Sidebar.defaultProps = {
  component: 'aside',
};

const mapState = state => ({
  showServiceMessage: state.message[state.intl.countryCode].showMessage,
});

export default compose(withStyles(s), connect(mapState))(Sidebar);
